import { Input, Table, TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import AddIcon from "components/Icons/AddIcon";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import Action from "./components/Action";
import { RouteName } from "constants/route";
import { FaqAlertContextProvider } from "./components/AlertContext";
import { IFaq, IFaqType } from "models/faq";
import useFaq from "hooks/faq/useFaq";

export default function Faq() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
  } = useFaq();

  return (
    <FaqAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.CREATE_FAQ}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">Add Faq</span>
            </Link>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </FaqAlertContextProvider>
  );
}

const columns: TableColumnsType<IFaq> = [
  {
    title: "Title",
    dataIndex: "title",
    sortIcon,
    sorter: (a, b) => a.title.localeCompare(b.title),
  },
  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (value: IFaqType) => (
      <p
        className={`capitalize font-bold ${
          value === "driver" ? "text-orange-600" : "text-green-600"
        }`}
      >
        {value}
      </p>
    ),
  },
  {
    title: "Action",
    render: (value: IFaq) => <Action faq={value} />,
  },
];
